import React from 'react';
import Dropdown from 'components/common/dropdowncomponents/dropdown';
import DropdownItem from 'components/common/dropdowncomponents/dropdownitem';
/*
This component is used in
components/pages/live/index.jsx
components/pages/sensorsettings/index.jsx
components/pages/user/index.js
*/
const optionClicked = (props, node) => {
	props.click(node);
}
const NodeDropdown = (props) => {
	var areas = [];
	props.root.children.forEach((child) => {
		props.list(child, areas);
	})
	var header = (props.nodeFilter.id == props.root.id) ? props.header : props.nodeFilter.info.name;

	return (
		<div className={props.outsideClass}>
			<Dropdown
				toggleable={true}
				header={header}
				className={props.className}
			>
				<DropdownItem>
					<div onClick={optionClicked.bind(this, props, props.root)}>
						{props.header}
					</div>
				</DropdownItem>
				{
					areas.map(
						(x, idx) => (
							<DropdownItem key={x.id}>
								<div onClick={optionClicked.bind(this, props, x)}>
									{x.info.name}
								</div>
							</DropdownItem>
						)
					)
				}
			</Dropdown>
		</div>
	)
}
export default NodeDropdown


// WEBPACK FOOTER //
// ./src/components/common/dropdowncomponents/nodedropdown/index.jsx